const ORDER = [
  "BRIEF RECEIVED", "AWAITING PAYMENT", "QUEUED", "IN DESIGN",
  "IN REVIEW", "REVISION REQUESTED", "APPROVED", "COMPLETED",
];

export default function StatusTimeline({ status, history = [] }) {
  const currentIdx = ORDER.indexOf(status);
  const byStatus = {};
  history.forEach((h) => (byStatus[h.status] = h));

  return (
    <ol data-testid="status-timeline" className="relative">
      <div className="hidden sm:block absolute top-[9px] left-0 right-0 h-px bg-white/10" />
      <div className="grid grid-cols-1 sm:grid-cols-8 gap-y-6">
        {ORDER.map((s, i) => {
          const state = i < currentIdx ? "done" : i === currentIdx ? "current" : "upcoming";
          const entry = byStatus[s];
          return (
            <li key={s} className="relative flex sm:flex-col items-start gap-3 sm:gap-0" data-testid={`timeline-step-${s.toLowerCase().replace(/ /g, "-")}`}>
              <span
                className={`relative z-10 mt-0.5 sm:mt-0 h-[18px] w-[18px] shrink-0 rounded-full border-2 ${
                  state === "done"
                    ? "bg-arsenal border-arsenal"
                    : state === "current"
                      ? "bg-arsenal border-arsenal shadow-[0_0_0_5px_rgba(229,9,20,0.25)] animate-pulse"
                      : "bg-ink border-white/20"
                }`}
              />
              <div className="sm:mt-3 sm:pr-2">
                <p className={`font-mono text-[9px] sm:text-[10px] tracking-[0.14em] leading-tight ${state === "upcoming" ? "text-slate-600" : state === "current" ? "text-arsenal" : "text-slate-300"}`}>
                  {s}
                </p>
                {entry?.at && (
                  <p className="mt-1 text-[10px] text-slate-500">{new Date(entry.at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}</p>
                )}
              </div>
            </li>
          );
        })}
      </div>
    </ol>
  );
}
